import React from 'react';
import { ApplicationIcon, Typography } from '@saviynt/design-system';

import type { AttributeMappingConfig } from '../../data-layer/types';

import './AttributeMappingHeader.css';

/**
 * AttributeMappingHeader component for column headers
 */
function AttributeMappingHeader({
  config,
}: {
  config: AttributeMappingConfig;
}) {
  return (
    <div className='attribute-mapping-header'>
      {/* Left Side - Saviynt Header */}
      <div className='header-cell saviynt-header'>
        <div className='header-icon'>
          <ApplicationIcon logo='Saviynt' size='xSmall' />
        </div>
        <Typography kind='body1-bold' color='--color-foreground-neutral'>
          <span style={{ paddingRight: '8rem' }}>
            {config.saviyntApp.name} Fields
          </span>
        </Typography>
      </div>

      {/* Right Side - External App Header */}
      <div className='header-cell'>
        <div className='application-header-icon'>
          <ApplicationIcon logo='Application' size='xSmall' />
        </div>
        <Typography kind='body1-bold' color='--color-foreground-neutral'>
          {config.externalApp.name} Fields
        </Typography>
      </div>
    </div>
  );
}

export default AttributeMappingHeader;
